import { createFileRoute, Link } from "@tanstack/react-router";
import { Box } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminProgramSetsList from "@/features/assessments/components/admin/AdminProgramSetsList";
import { useProgramsPermissions } from "@/pages/admin/programs";
import PageNotFound from "@/common/components/views/PageNotFound";

export const Route = createFileRoute("/app/admin/programs/$programId/sets")({
  component: RouteComponent,
});

function RouteComponent() {
  const { programId } = Route.useParams();
  const { programs, userCanViewAllPrograms, userCanViewAllSets } = useProgramsPermissions();

  if (!userCanViewAllPrograms || !userCanViewAllSets) {
    return <PageNotFound />;
  }

  const program = programs.data[programId];

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Programs", link: "/app/admin/programs" },
          { title: program.name, link: `/app/admin/programs/${program.id}` },
          { title: "Assessments", link: null },
        ]}
      />
      <Box component="h1" sx={{ m: 0, pr: 0.5 }}>
        Program Assessments
      </Box>

      <Box sx={{ mb: 1 }}>
        <p>
          <em>
            For <Link to="/app/admin/programs/$programId" params={{ programId: String(program.id) }}>{program.name}</Link> ({program.id})
          </em>
        </p>
      </Box>
      <AdminProgramSetsList
        itemsPerPage={25}
        programId={program.id}
        renderVersion={0}
        tableSize="medium"
        userCanViewAllPrograms={userCanViewAllPrograms}
        userCanViewAllSets={userCanViewAllSets}
      />
    </>
  );
}
